import { Component, Input } from '@angular/core';

@Component({
    selector: 'carm-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent {
  @Input() iconColor = '#26374a';
  @Input() showOnHover: boolean;
  @Input() stopPropagation: boolean = false;

  onClick(event: MouseEvent): void {
    if(this.stopPropagation)
    {
      event.stopImmediatePropagation();
    }
  }
}
